import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from "@angular/core";
import { CdkCopyToClipboard } from "@angular/cdk/clipboard";
import { SvgIconComponent } from "angular-svg-icon";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-copiable-device-info",
  templateUrl: "./copiable-device-info.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./copiable-device-info.component.scss"],
  imports: [CdkCopyToClipboard, SvgIconComponent, TranslateModule]
})
export class CopiableDeviceInfoComponent implements OnInit {
  @Input() labelPath: string;
  @Input() value?: string;
  @Input() icon?: string;
  @Input() iconColor?: string;

  public displayCheck: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  public onClipboardCopy(_successful: boolean): void {
    this.displayCheck = true;
    setTimeout(() => {
      this.displayCheck = false;
    }, 1800);
  }
}
